export const errTooManyUnarchivedUnpausedSkanCampaigns = '01-001';
export const errNotEnoughAvailableSkanIDs = '01-002';
export const errCanNotRestoreCampaignWithSchema0 = '01-003';
export const errCanNotActivateNonMmpCampaignWithSchema0 = '01-004';

export function shouldShowSkanAlert(code) {
  return code === errTooManyUnarchivedUnpausedSkanCampaigns || code === errNotEnoughAvailableSkanIDs;
}
